import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import snakeCase from 'lodash/snakeCase'
import isPlainObject from 'lodash/isPlainObject'

interface IObject {
  [key: string]: any
}

export default function convertToSnakeCase(hash: IObject, keysToSkip?: string[]): IObject {
  return mapKeysDeep(hash, snakeCase, keysToSkip)
}

const mapKeysDeep = (hash: IObject, callback: (key: any) => {}, keysToSkip?: string[]): any[any] => {
  const keys = mapKeys(hash, (_value, key) => {
    return callback(key)
  })

  return mapValues(keys, (val, key) => {
    if (Array.isArray(val) && !keysToSkip?.includes(key)) {
      return val.map(item => isPlainObject(item) ? mapKeysDeep(item, callback, keysToSkip) : item)
    }

    return shouldCallRecursively(val, key, keysToSkip) ? mapKeysDeep(val, callback, keysToSkip) : val
  })
}

const shouldCallRecursively = (val: any, key: string, keysToSkip?: string[]): boolean => {
  return !keysToSkip?.includes(key) && isPlainObject(val)
}
